import React, {Component} from 'react';
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';

export default class Dialog extends Component {
    render() {
        return (
            <Modal isOpen={this.props.isOpen}>
                <ModalHeader>
                    {this.props.title}
                </ModalHeader>
                <ModalBody>
                    {this.props.children}
                </ModalBody>
                <ModalFooter>
                    <Button color='danger'
                            onClick={this.props.confirm}>
                        {this.props.confirmText || 'Bestätigen'}
                    </Button>
                    <Button color='default' onClick={this.props.toggle}>
                        {this.props.cancelText || 'Abbrechen'}
                    </Button>
                </ModalFooter>
            </Modal>
        )
    }
}